import React, { useState } from "react";
import "./Css/Contact.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const phoneNumber = "919172554563";

    // WhatsApp Compatible Message
    const message =
      "📩 *नवीन संपर्क संदेश*\n" +
      "-----------------------------\n" +
      `👤 *नाव:* ${formData.firstName} ${formData.lastName}\n` +
      `📧 *ईमेल:* ${formData.email}\n` +
      `📞 *संपर्क:* ${formData.phone}\n` +
      `💬 *संदेश:* ${formData.message}`;

    const encodedMessage = encodeURIComponent(message);

    // WhatsApp Web API → Direct App Open
    const whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

    // OPEN USING window.open (BEST & MOST RELIABLE)
    window.open(whatsappURL, "_blank");
  };

  return (
    <section className="contact-section">
      <div className="contact-left">
        <h1>आपला सहयोग, आमची प्रगती</h1>
        <p>चला एकत्र येऊन आपल्या गावाचं उज्ज्वल भविष्य घडवूया!!</p>

        <form className="vm-form" onSubmit={handleSubmit}>
          <div className="vm-row">
            <div className="vm-field">
              <label>नाव</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="vm-field">
              <label>आडनाव</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="vm-row">
            <div className="vm-field">
              <label>ईमेल</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="vm-field">
              <label>संपर्क क्रमांक</label>
              <input
                type="number"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="vm-field">
            <label>आपला संदेश</label>
            <textarea
              name="message"
              rows="3"
              placeholder="तुमचा संदेश लिहा..."
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="vm-btn">सबमिट करा</button>
        </form>
      </div>

      <div className="contact-right">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3802.262766885889!2d74.12097767421554!3d17.637709495547462!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc231b709c8dbc7%3A0x9ee514009278f97a!2z4KSX4KWN4KSw4KS-4KSu4KSq4KSC4KSa4KS-4KSv4KSkIOCkpOCkvuCkuOCkl-CkvuCktQ!5e0!3m2!1sen!2sin!4v1763046681203!5m2!1sen!2sin"
          width="450"
          height="500"
          allowFullScreen
          loading="lazy"
          title="Village Location"
        ></iframe>
      </div>
    </section>
  );
};

export default ContactForm;
